import { cn } from '@repo/tailwind-config/tailwind.functions'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

type Props = {
  comment: string
  date: Date
  index: number
  className?: string
  dateFormatter: (date: Date) => string
}

const LogItem = ({ comment, date, index, className, dateFormatter }: Props) => {
  return (
    <div className={cn('flex flex-row gap-2 bg-white-dark rounded-lg p-3', className)}>
      <div
        className={
          'p-2 bg-primary-light rounded-sm h-7 flex justify-center items-center text-primary'
        }
      >
        <Typography variant="label-semibold">{index}</Typography>
      </div>

      <div className={'flex flex-col gap-2'}>
        <Typography variant={'secondary-body'}>{comment}</Typography>
        <Badge text={dateFormatter(date)} variant={'darkBlue'} />
      </div>
    </div>
  )
}

export default LogItem
